module.exports = __webpack_public_path__ + "static/fanny_wautelet-bad72660709d690799823849d9040712.png";